import React from 'react';
import Navbar from '../components/Navbar';
import HeroBanner from '../components/HeroBanner';
import StatsSection from '../components/StatsSection';
import ServicesGrid from '../components/ServicesGrid';
import WhyUs from '../components/WhyUs';
import CtaBanner from '../components/CtaBanner';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Navbar />
      <HeroBanner />
      <StatsSection />
      <ServicesGrid />
      <WhyUs />
      <CtaBanner />
      <Footer />
    </>
  );
};

export default Home;
